import { useNavigate } from 'react-router-dom'

type ChangeCareersActionsProps = {
  handleCareerPath: () => void
  handleAssessments: () => void
  handleOpenBookCoach: () => void
}

export const useChangeCareersActions = (): ChangeCareersActionsProps => {
  const navigate = useNavigate()

  const handleCareerPath = () => {
    navigate('/career-path')
  }

  const handleAssessments = () => {
    navigate('/career-profile/chat')
  }

  const handleOpenBookCoach = () => {
    navigate('/career-coaching')
  }

  return {
    handleCareerPath,
    handleAssessments,
    handleOpenBookCoach,
  }
}
